const generateOTP = (seed) => {
    const a = 1664525;
    const c = 1013904223;
    const m = 4294967296; // 2^32 (32-bit unsigned integer range)
  
    // Set the seed
    let currentSeed = seed % m;
  
    // LCG algorithm
    const generateRandom = () => {
      currentSeed = (a * currentSeed + c) % m;
      return currentSeed;
    };
  
    // Generate the 6-digit number
    let randomNumber = '';
    for (let i = 0; i < 6; i++) {
      randomNumber += generateRandom() % 10;
    }
  
    return randomNumber;
}

module.exports = generateOTP;
